import React from "react";
import { Layout, Tooltip, Button, Row, Col, Space } from "antd";
import { useDispatch } from "react-redux";
import { FiMenu } from "react-icons/fi";
// component
import HeaderUser from "component/header/header_user";
//redux
import { toggleCollapse } from "../../../store/bailiff/nav/nav.action";
import logo from "../../../config/img/logo.png";
// import NotifyHeader from "component/header/notify/notify_header";

const LayoutHeader = (props) => {
  // -------------------------- STATE --------------------------
  const { title } = props;
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  const toggleMenu = () => {
    dispatch(toggleCollapse());
  };

  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Row>
        <Col flex="50px">
          <div className="justify-center">{renderMenu()}</div>
        </Col>
        <Col flex="auto">{renderTitle()}</Col>
        <Col align="right" flex="300px">
          {renderLogout()}
        </Col>
      </Row>
    );
  };

  const renderMenu = () => {
    return (
      <Tooltip title="Menu">
        <Button
          shape="default"
          onClick={() => toggleMenu()}
          icon={
            <span className="anticon">
              <FiMenu />
            </span>
          }
        />
      </Tooltip>
    );
  };

  const renderTitle = () => {
    const size = 35;
    return (
      <Space>
        <a href="/" style={{ display: "flex", alignItems: "center" }}>
          <img src={logo} style={{ width: size, height: size }} alt="logO" />
        </a>
        <div className="header-title">{title || ""}</div>
      </Space>
    );
  };

  const renderLogout = () => {
    return (
      <div className="flex flex-row justify-end gap-2">
        {/* <NotifyHeader /> */}
        <HeaderUser />
      </div>
    );
  };
  // -------------------------- MAIN --------------------------
  return <Layout.Header className="header-menu">{renderBody()}</Layout.Header>;
};

export default LayoutHeader;
